import { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Typography,
    TextField,
    useTheme,
    Alert,
    Link
} from '@mui/material';
import '../../index.css';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/axios';
import { useLocation } from 'react-router-dom';

const RESETPASS = "/resetpass/";

export const ResetPassword = () => {
    const theme = useTheme();
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [linkClicked, setLinkClicked] = useState(false);
    const [linkClickedWaiting, setLinkClickedWaiting] = useState(false);
    const [validEmail, setValidEmail] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const expiredLink  = location.state?.expiredLink;

    const sendEmailRequest = async (emailReceiver) => {
        try {
            const res = await axios.post(RESETPASS, {
                email: emailReceiver
            });

            const { code, message } = res.data;
            setLinkClicked(true);

        } catch (err) {
            console.error("Error archiving plan:", err);
        }
    };

    return (
        <>
            <Box sx={{
                width: '100%',
                minHeight: '100vh',
                backgroundColor: '#fff',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflowY: 'hidden'
            }} >

                <Box sx={{
                    width: '100%',
                    maxWidth: 600,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    gap: 2
                }} >
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
                            if (!isValidEmail) {
                                setLinkClicked(false);
                                setEmailError('Invalid email address');
                                return;
                            }
                            else {
                                setEmailError('');
                                sendEmailRequest(email);
                                setLinkClickedWaiting(true);
                            }

                        }}
                        style={{
                            width: '100%',
                            maxWidth: 600,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 16,
                        }}
                    >

                        {/* Logo */}
                        <Typography
                            variant="h2"
                            sx={{
                                textAlign: 'center',
                                width: '100%',
                                color: '#1565C0',
                            }}
                        >
                            <span style={{ color: '#1565C0' }}>Ocu</span>
                            <strong style={{ color: '#000000', fontWeight: 'bold' }}>Build</strong>
                        </Typography>

                        {/* Title */}
                        <Typography gutterBottom sx={{ fontSize: 38, mb: 0, mt: 1 }}>
                            Reset password
                        </Typography>

                        <Typography variant="body2" gutterBottom sx={{ fontSize: '1.05em', mb: 0, mt: -2 }}>
                            Enter your registered email address to get a link to reset your password
                        </Typography>

                        {linkClicked && (
                            <Alert severity="success" sx={{ mt: 1 }}>
                                <Typography variant="subtitle2" color="#1E4620" sx={{ mt: 0 }}>
                                    Check your email
                                </Typography>
                                <Typography variant="body2" color="#1E4620">
                                    If that email is in our system, we’ll send a link to  reset your password. Please check your inbox and spam folder.
                                </Typography>
                            </Alert>
                        )}

                        {expiredLink && !linkClicked && (
                            <Alert severity="warning" sx={{ mt: 1 }}>
                                <Typography variant="subtitle2" color="#663C00" sx={{ mt: 0 }}>
                                    Secure link expired
                                </Typography>
                                <Typography variant="body2" color="#663C00">
                                    Please request a new link below. 
                                    <br />
                                    For your protection, password reset links are valid for 2 hours. Requesting a new one deactivates any previous links.
                                </Typography>
                            </Alert>
                        )}

                        {/* Email Field */}
                        <TextField
                            fullWidth
                            label="Email"
                            variant="standard"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setEmailError('');

                                const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value);

                                if (!isValidEmail) {
                                    setValidEmail(false);
                                }
                                else {
                                    setValidEmail(true);
                                }
                            }}
                            error={!!emailError}
                            autoComplete="email"
                            autoFocus
                            disabled = {linkClickedWaiting}
                            sx={{ width: "100%" }}
                        />

                        {/* Sign In + Forgot */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                mt: 4,
                            }}
                        >
                            {!linkClicked && (
                                <Button
                                    variant="contained"
                                    size="medium"
                                    sx={{ height: 40 }}
                                    type="submit"
                                    disabled={linkClickedWaiting || !validEmail}
                                >
                                    SEND RESET LINK
                                </Button>
                            )}

                            {linkClicked && (
                                <Button
                                    variant="contained"
                                    size="medium"
                                    sx={{ height: 40 }}
                                    onClick={() => navigate('/login')}
                                >
                                    BACK TO SIGN IN
                                </Button>
                            )}

                            {!linkClicked && (
                                <Link
                                    variant="body2"
                                    underline="none"
                                    onClick={() => navigate('/login')}
                                    sx={{
                                        color: theme.palette.grey[600],
                                        ml: 2,
                                        cursor: 'pointer',
                                        '&:hover': {
                                            textDecoration: 'underline',
                                        },
                                    }}
                                >
                                    Back to sign in
                                </Link>
                            )}
                        </Box>
                    </form>
                </Box>
            </Box>
        </>
    );
};
